import { arrangeValuesByDimension } from './arrangeValuesByDimension';
import { getDimensionKeys } from './getDimensionKeys';
import { getDimensionInfo } from './getDimensionInfo';
import {
	getAllPeriodDates,
	getPeriodDatesInRange,
} from './getPeriodDatesInRange';
import { getGlobalDataProperties } from '../../helpers/getGlobalDataProperties';
import {
	WebAPIDataEntryList,
	WebAPILineGraphChartSlicerData,
} from '../../../../globals/webApiTypes/elements/WebAPICBS';

export const getLineGraphProps = ({
	multiDimension,
	topicKeys,
	selectedTopics,
	selectedCategories,
	periodType,
	dataEntryList,
	labelAliases,
}: { dataEntryList: WebAPIDataEntryList } & Pick<
	WebAPILineGraphChartSlicerData,
	| 'multiDimension'
	| 'labelAliases'
	| 'topicKeys'
	| 'selectedTopics'
	| 'selectedCategories'
	| 'periodType'
>) => {
	const decimals = Object.values(selectedTopics)?.[0].decimals ?? 0;
	const unit = Object.values(selectedTopics)?.[0].unit ?? '';

	const valuesByDimension = arrangeValuesByDimension({
		dataEntryList,
		multiDimension,
		topicKeys,
	});
	const dimensionKeys = getDimensionKeys(valuesByDimension);
	const allPeriodDates = getAllPeriodDates(dataEntryList);

	const periodDatesInRange = getPeriodDatesInRange({
		allPeriodDates,
		dimensionKeys,
		periodType,
		valuesByDimension,
	});
	const dimensionInfo = getDimensionInfo({
		dimensionKeys,
		valuesByDimension,
		multiDimension,
		selectedTopics,
		selectedCategories,
		labelAliases,
		periodDatesInRange,
	});
	const globalDataProperties = getGlobalDataProperties({
		dimensionInfo,
		decimals,
	});

	return {
		valuesByDimension,
		dimensionInfo,
		periodDatesInRange,
		unit,
		decimals,
		...globalDataProperties,
	};
};
